import { useRecentActivity } from '@/client/hooks/use-recent-trades';
import { cn } from '@/client/utils';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';

import { ActivityLine } from './activity-line';

// Single-line, site-wide activity broadcast for the desktop footer. One trade
// is shown at a time; every ROTATE_MS the current line slides up and out while
// the next slides up from below (a vertical swap, not a horizontal marquee).
// Kept slow so each line is comfortably readable rather than flickering past.
const ROTATE_MS = 6000;

export const TheActivityTicker = ({ className }: { className?: string }) => {
  const trades = useRecentActivity(20);

  const [index, setIndex] = useState(0);
  useEffect(() => {
    if (trades.length < 2) return;
    const id = setInterval(() => setIndex(i => i + 1), ROTATE_MS);
    return () => clearInterval(id);
  }, [trades.length]);

  if (trades.length === 0) return null;

  const trade = trades[index % trades.length];

  return (
    <div className={cn('h-6 overflow-hidden text-xs leading-6', className)}>
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={trade.uuid}
          initial={{ y: '100%', opacity: 0 }}
          animate={{ y: '0%', opacity: 1 }}
          exit={{ y: '-100%', opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeInOut' }}
          className="flex h-6 items-center"
        >
          <ActivityLine trade={trade} />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

TheActivityTicker.displayName = 'TheActivityTicker';
